// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3NL27","errorLogs":"EditorFooter_errorLogs__3Pxh9"};